import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidWordSnake } from '../../../../mechanics/rid-word-snake/rid-word-snake';

@Component({
  selector: 'app-word-snake-page',
  imports: [RidWordSnake],
  templateUrl: './word-snake-page.html',
})
export class WordSnakePage {
  protected readonly $router = inject(Router);
}
